import React,{useState,}from 'react'
import { Modal,Form,Input, Button,message} from 'antd';
import { useBnsBaoZhuangAddMutation } from '../../store/ReactWebSiteApi';
import GetUserDept from '../../cpn/GetUserDept';
import MyEditor from '../../cpn/MyEditor';
import ProductForm from '../../backend/project/ProjectSelect';
import MediaForm from '../../promote/media/MediaForm';
function PackageAdd() {    
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);   
    const [add]  = useBnsBaoZhuangAddMutation()
    const [info,setInfo] = useState({
        bbz_content:'',
    });
    return (
            <>
                <Button
                    onClick={() => {setOpen(true)}}
                    type='primary'
                >新增</Button>
                <Modal
                    width={1000}
                    open={open}
                    title='新增推广方案'
                    okText="提交"
                    cancelText="取消"
                    onCancel={() => {setOpen(false);}}
                    onOk={() => {
                        form
                            .validateFields()
                            .then((values) => {
                                form.resetFields();  
                                add({
                                    "bbz_bg_id" : info.bbz_bg_id,
                                    "bbz_bg_name" : info.bbz_bg_name,
                                    "bbz_cid" : localStorage.getItem('eu_id'),
                                    "bbz_cname" : localStorage.getItem('eu_name'),
                                    "bbz_content" : info.bbz_content,
                                    "bbz_dept_id" : info.bbz_dept_id,
                                    "bbz_dept_name" : info.bbz_dept_name,
                                    "bbz_e_id" : localStorage.getItem('e_id'),
                                    "bbz_name" : info.bbz_name,
                                    "bbz_type_id" : info.bbz_type_id,
                                    "bbz_type_name" : info.bbz_type_name,                           
                                }).then((res) => {
                                    if (res.data.Status === 'success') {
                                        message.info('新增成功！');
                                        setOpen(false);
                                    }
                                    if (res.data.Status === "fail") {
                                        message.error('新增失败！'+res.data.Message)
                                    }
                                })                        
                            })
                            .catch((info) => {
                                console.log('Validate Failed:', info);
                            });                    
                    }}
                >
                    <Form
                        form={form}
                        layout="horizonal"
                        name="form_client_add"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 3 }}
                    >
                        <GetUserDept 
                            label='部门'
                            required
                            wrapperCol={{span:10}} 
                            getUserDept={(e,f) => {
                                setInfo(prevState=>({...prevState,bbz_dept_id:e,bbz_dept_name:f}))
                            }}
                        />
                        <ProductForm
                            wrapperCol={{span:10}}
                            required    
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bbz_bg_id:e,bbz_bg_name:f.label}))
                            }}
                        />
                        <MediaForm
                            wrapperCol={{span:10}}
                            required
                            onChange={(e,f) => {
                                setInfo(prevState=>({...prevState,bbz_type_id:e,bbz_type_name:f.label}))
                            }}
                        />                       
                        <Form.Item name="name" label='标题' wrapperCol={{span:20}} required>
                            <Input 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bbz_name:e.target.value}))}}
                            />
                        </Form.Item> 
                        <Form.Item name="remark" label='正文' wrapperCol={{span:20}}>
                            <MyEditor 
                                onChange={(e) => {setInfo(prevState=>({...prevState,bbz_content:e}))}}
                            />
                        </Form.Item> 
                    </Form>
                </Modal>
            </>
        )
}

export default PackageAdd